export interface SetExchangeIdAction {
  type: "SET_EXCHANGE_ID";
  data: string;
}

export function setExchangeId(exchangeId: string): SetExchangeIdAction {
  return {
    type: "SET_EXCHANGE_ID",
    data: exchangeId,
  };
}
